import { Chip, Tooltip } from "@mui/material";
import QrCode2Icon from "@mui/icons-material/QrCode2";

/**
 * نمایش کد عمومی کوتاه تجهیز (مثل PNL-000001) به‌صورت چیپ.
 * اگر کدی وجود نداشته باشد چیزی نمایش داده نمی‌شود.
 */
const EquipmentPublicCodeChip = ({ code, title, size = "small", sx = {} }) => {
  if (!code) return null;
  const chip = (
    <Chip
      size={size}
      icon={<QrCode2Icon sx={{ fontSize: "1rem" }} />}
      label={code}
      variant="outlined"
      color="primary"
      sx={{
        fontFamily: "monospace",
        letterSpacing: 0.5,
        direction: "ltr",
        ...sx,
      }}
    />
  );
  return title ? <Tooltip title={title}>{chip}</Tooltip> : chip;
};

export default EquipmentPublicCodeChip;
